export default __webpack_public_path__ + "static/media/power-switch.d369fd87.svg";